import { Alert, Button, Form, Row } from 'react-bootstrap';

import RegisterStepper from './RegisterStepper';

const CustomizeYourWorkspace = (props: any) => {
  return (
    <Row className="align-items-center justify-content-center">
      {/*<Finger3 />*/}
      <h2 className="text-center mb-0 fw-bold register-title">Dernière étape</h2>
      <h3 className="text-center mb-4 fw-bold register-subtitle">Personnalisez votre espace !</h3>
      <Form className="register-form" noValidate validated={props.validatedWorkspace}>
        <RegisterStepper step={2} />
        <Form.Group className="mt-4 mb-4" controlId="validationInputSubDomain">
          <Form.Control
            type="text"
            placeholder="Nom de votre société"
            aria-label="Nom de votre société"
            aria-describedby="inputSubDomain"
            onChange={(e) => props.setCompanyName(e.target.value)}
            value={props.companyName}
            required
          />
        </Form.Group>
        <Form.Group className="mb-4" controlId="estimatedPropertyNumber">
          <Form.Select
            aria-label="Nombre de biens en gestion"
            control-id="estimatedPropertyNumber"
            required
            onChange={(e) => {
              props.setEstimatedPropertyNumber(e.target.value);
            }}
          >
            <option>Nombre de biens en gestion</option>
            <option value="10">10</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </Form.Select>
        </Form.Group>
        <Form.Group className="mb-4" controlId="managerType">
          <Form.Select
            aria-label="Type de gestionnaire"
            control-id="managerType"
            required
            onChange={(e) => {
              props.setManagerType(e.target.value);
            }}
          >
            <option>Vous êtes ...</option>
            <option value="realEstateAdministrator">Administrateur de biens</option>
            <option value="realEstateAgency">Agence immobilière</option>
            <option value="socialLandlord">Bailleur social</option>
            <option value="propertyManager"> Gestionnaire immobilier</option>
            <option value="land">Foncière</option>
            <option value="other">Autre</option>
          </Form.Select>
        </Form.Group>

        {props.error !== '' && <Alert variant="danger">{props.error}</Alert>}

        <div className="text-center">
          <Button className="mt-4 mb-5 btn-register" variant="primary" onClick={props.handleSubmitWorkspace}>
            Suivant
          </Button>
        </div>
      </Form>
    </Row>
  );
};
export default CustomizeYourWorkspace;
